var render = function render(){var _vm=this,_c=_vm._self._c;return _c('core-filter-advanced-group',{attrs:{"title":"Types","count":_vm.count}},[_c('core-filter-input-suggest',{attrs:{"placeholder":"Start typing a type...","has-require":true,"toggle":true,"field":"subdomain_name","filter":_vm.value('subdomains'),"api":"subdomains/suggest","data":"subdomains"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }